import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStatus from 'hooks/auth/useAuthStatus';
import Loading from 'components/Loading';

export default ({ element: Component, redirect='/', ...props }) => {

    const { isAuthenticated, checked } = useAuthStatus();

    if (!checked) {
        return <Loading />;
    }

    if (isAuthenticated) {
        return <Component {...props} />
    }

    return <Navigate to={{ pathname: redirect, state: {from: props.location}}} />;
}
